export default __webpack_public_path__ + "static/media/Pilates.d7b6b230.mp4";